export const FORGOT_PASSWORD_DIALOG_TITLE = 'forgot-password-dialog.title';
export const FORGOT_PASSWORD_DIALOG_BUTTON_TEXT = 'forgot-password-dialog.button-text';
export const FORGOT_PASSWORD_DIALOG_ICON_ALT = 'forgot-password-dialog.icon-alt';
